module.exports = __webpack_public_path__ + "static/punch-0a0d65732f3116f98e55501483003b24.mp3";